import React, {useEffect, useState} from 'react'
import {Translate} from "../../../../components/translate/Translate";
import {useTranslation} from "react-i18next";
import { useSelector } from 'react-redux';

interface ITimesheetHeaderTaskProps {
    setTaskData: any
    taskData: string
}

export const TimesheetHeaderTask: React.FC<ITimesheetHeaderTaskProps> = ({setTaskData, taskData}) => {

    const [valueField, setValueField] = useState("")

    const language = useSelector((state: any) => state.toolkit.language)

    const handleChangeInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValueField(e.target.value)
        setTaskData(e.target.value)
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey) {
            (e.target as HTMLTextAreaElement).blur();
        }
    }

    useEffect(() => {
        setValueField(taskData)
    }, [taskData])

    const {t} = useTranslation();

    return (
        <div className="section-table__add-task--text">
            <label className="textarea-wrapper">
                <span className="textarea-wrapper__inner" data-value={valueField}>
                    <textarea 
                        name="task" 
                        value={valueField} 
                        placeholder={`${t("timesheet_page.top_part.tell_us_your_secrets")}`}
                        className="textarea"
                        onChange={handleChangeInput}
                        onKeyDown={handleKeyDown}
                        rows={1}
                        lang={language} 
                        spellCheck 
                        required
                    ></textarea>
                </span>
            </label>
        </div>
    )
}
